import { createFileRoute } from '@tanstack/react-router';
import { PendingPage } from '@/features/review/pages';

// «Da approvare» (ADR 0086): revisions not on Dokless yet while the automatic mode is off.
export const Route = createFileRoute('/_app/shipments/approve')({
  component: PendingPage,
});
